import LTR from "@brand-icons/global/pin-time&place/pin-time&place-ltr.svg";

import { iconFactory } from "../iconFactory";

export const PinTimePlaceIcon = iconFactory("PinTimePlaceIcon", LTR);
